module.exports = __webpack_public_path__ + "static/img/avatar3.41b631f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar3.png
// module id = msjg
// module chunks = 7